<template>
    <div class="login-page">
        <div class="login-container">
            <div class="login-content">
                <div class="login-logo">
                    <div class="logo-icon" @click="gouon">课</div>
                    <h1>课后AI辅导系统V1.0</h1>
                </div>
                
                <div class="login-methods">
                    <PhoneLogin @login-success="handleLoginSuccess" />
                </div>
                
                <div class="login-footer">
                    <p>登录即表示同意 <a href="#">用户协议</a> 和 <a href="#">隐私政策</a></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PhoneLogin from '@/components/login/PhoneLogin.vue'
//import WechatLogin from '@/components/login/WechatLogin.vue'

export default {
    name: 'Login',
    components: {
        PhoneLogin,
        //WechatLogin
    },
    
    methods: {
        gouon(){
            this.$router.push({
                path: '/',
            })
        },
        handleLoginSuccess(userData) {
            this.$store.dispatch('login', userData)
            this.$store.dispatch('showToast', `欢迎回来，${userData.name}！`)
            
            // 跳转到之前的页面或首页
            const redirect = this.$route.query.redirect || '/'
            this.$router.push(redirect)
        }
    }
}
</script>

<style scoped>
.login-page {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
}

.login-container {
    width: 100%;
    max-width: 440px;
}

.login-header {
    margin-bottom: 40px;
}

.back-link {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    color: var(--text-dark);
    text-decoration: none;
    font-size: 16px;
    transition: color 0.3s;
}

.back-link:hover {
    color: var(--primary);
}

.login-content {
    background: var(--bg-glass);
    backdrop-filter: blur(var(--blur-lg));
    border: 1px solid var(--border-light);
    border-radius: var(--radius-lg);
    padding: 48px;
    box-shadow: var(--shadow-xl);
}

.login-logo {
    text-align: center;
    margin-bottom: 48px;
}

.logo-icon {
    width: 48px;
    height: 48px;
	background: linear-gradient(135deg, var(--china-red) 0%, var(--asean) 100%);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 24px;
    font-weight: bold;
    box-shadow: 0 4px 12px rgba(13, 71, 161, 0.2);
    margin: 0 auto 10px;
}


.login-logo h1 {
    font-size: 24px;
    font-weight: 700;
    color: var(--text-dark);
    letter-spacing: -0.02em;
}

.divider {
    text-align: center;
    margin: 32px 0;
    position: relative;
}

.divider span {
    background: white;
    padding: 0 16px;
    color: var(--text-light);
    position: relative;
    z-index: 1;
}

.divider::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    height: 1px;
    background: var(--border-light);
}

.login-footer {
    margin-top: 32px;
    text-align: center;
    font-size: 14px;
    color: var(--text-light);
}

.login-footer a {
    color: var(--primary);
    text-decoration: none;
}
</style>